import { render } from "./FormRadio.vue?vue&type=template&id=6d1d20cc&ts=true"
import script from "./FormRadio.vue?vue&type=script&lang=ts"
export * from "./FormRadio.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__